module.exports = __webpack_public_path__ + "static/media/img2-4.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img2-4.png
// module id = 1434
// module chunks = 3